import { PatientPortalSystemOptions } from 'types/patient-portal-system.types';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { AmplarCompleteStep } from './amplar-complete-step.component';
import { MyHealthCompleteStep } from './my-health-complete-step.component';

export interface CompleteStepProps {
  onComplete: () => void;
}

export const CompleteStep = ({ onComplete }: CompleteStepProps) => {
  const { systemId } = usePatientPortalContext();
  const SystemCompleteStepMap: Record<
    PatientPortalSystemOptions,
    React.FC<CompleteStepProps>
  > = {
    myhealth: MyHealthCompleteStep,
    amplar: AmplarCompleteStep,
  };

  const SystemCompleteStep = SystemCompleteStepMap[systemId];

  return <SystemCompleteStep onComplete={onComplete} />;
};
